import React from 'react';

// UserDetails form copy/config. Copied from components/Home/Verification/constants
// (still shared with utils/utilities via ADDRESS_FIELD) — the legacy originals are
// left untouched and removed at phase end (deferred-cleanup-tracker S.4).

export const USER_DETAIL_FORM_CONDITIONS = {
    INFORMATION_MISMATCH: 'INFORMATION_MISMATCH',
    REQUIRE_FALLBACK: 'REQUIRE_FALLBACK',
    DEFAULT: 'DEFAULT',
};

export const USER_DETAIL_FORM = {
    HEADING: {
        [USER_DETAIL_FORM_CONDITIONS.INFORMATION_MISMATCH]: '⚠️ We Found a Mismatch',
        [USER_DETAIL_FORM_CONDITIONS.REQUIRE_FALLBACK]: 'Additional Information Needed',
        [USER_DETAIL_FORM_CONDITIONS.DEFAULT]: 'Confirm Information',
    },
    DESCRIPTION: {
        [USER_DETAIL_FORM_CONDITIONS.INFORMATION_MISMATCH]: (
            <>
                The information extracted from the uploaded ID does not fully match the details
                previously provided. <br />
                Please review and confirm the correct values to proceed with verification.
            </>
        ),
        [USER_DETAIL_FORM_CONDITIONS.REQUIRE_FALLBACK]: (
            <>
                The initial verification attempt couldn't be completed due to inconsistent or
                incomplete data. <br />
                To improve accuracy and complete the check, we need a bit more information from you.
            </>
        ),
        KBA: (
            <>
                Please confirm your information below to generate a personal, knowledge based
                authenticating quiz.
                <br />
                This option is only available to individuals in the US with a valid SSN.
            </>
        ),
        [USER_DETAIL_FORM_CONDITIONS.DEFAULT]: (
            <>
                Please confirm your information below before continuing. <br />
                The SSN option is only available to individuals in the US with a valid SSN.
            </>
        ),
    },
};

export const ADDRESS_FIELD = [
    'houseNumber',
    'streetName',
    'city',
    'zipCode',
    'state',
    'country',
    'address',
];

export const userDetailsFormInitialValues = {
    firstName: '',
    middleName: '',
    lastName: '',
    dob: null,
    houseNumber: '',
    streetName: '',
    apartmentNumber: '',
    city: '',
    state: '',
    zipCode: '',
    ssn: '',
    confirmSSN: '',
    acceptMiddleName: false,
    address: '',
    country: '',
};
